module.exports = __webpack_public_path__ + "img/services-portocaliu2.1825fd2f.svg";